import React, { Component } from 'react';
import PropTypes from 'prop-types';

import withTranslateChange from 'components/hocs/withTranslateChange';
import Table from 'components/common/Table';

@withTranslateChange(({ getList, supportActions = [] }) => {
    getList.refresh();

    supportActions.forEach(action => {
        action.refresh();
    });
})
export default class List extends Component {
    static propTypes = {
        getList: PropTypes.object.isRequired,
        supportActions: PropTypes.array,

        meta: PropTypes.object.isRequired,
        items: PropTypes.array.isRequired,
        settings: PropTypes.object,

        filters: PropTypes.object,
        sort: PropTypes.object,
        pagination: PropTypes.object,
        hideGroups: PropTypes.bool,

        tableConfig: PropTypes.object.isRequired,
        controls: PropTypes.func,

        setFilters: PropTypes.func,
        setSort: PropTypes.func,
        setPagination: PropTypes.func,
        setColumnWidth: PropTypes.func,
        setSelected: PropTypes.func,

        className: PropTypes.string,
    };

    handleFilters = (filters) => {
        this.props.setFilters(filters);
    }

    handleRefresh = () => {
        this.props.getList.refresh();
    }

    render() {
        const { className, controls: Controls } = this.props;
        const { meta, items, settings, sort, pagination, filters, hideGroups } = this.props;
        const { tableConfig, setPagination, setSort, setColumnWidth } = this.props;

        return (
            <div>
                { Controls && (
                    <div className="react-table-controls">
                        <Controls
                            filters={filters}
                            handleRefresh={this.handleRefresh}
                            handleFilters={this.handleFilters}
                        />
                    </div>
                )}
                <div>
                    <Table
                        className={className}
                        meta={meta}
                        items={items}
                        settings={settings}

                        sort={sort}
                        pagination={pagination}
                        hideGroups={hideGroups}

                        tableConfig={tableConfig}
                        setPagination={setPagination}
                        setSort={setSort}
                        setColumnWidth={setColumnWidth}
                        refresh={this.handleRefresh}
                    />
                </div>
            </div>
        );
    }
}
